import {createAction} from "redux-act";
import {IUser} from "modules/reducers/user";

export const userLogin = createAction();
export const userLoginSuccess = createAction<IUser>();
export const userLoginFailed = createAction<Error["message"]>();

export interface IUserBackdoorLoginPayload {
	email: string;
}

export const userPreregistration = createAction<IUserBackdoorLoginPayload>();
export const userPreregistrationSuccess = createAction();
export const userPreregistrationFailed = createAction<Error["message"]>();

export const userBackdoorLogin = createAction<IUserBackdoorLoginPayload>();
export const userBackdoorLoginSuccess = createAction<IUser>();
export const userBackdoorLoginFailed = createAction<Error["message"]>();

export const requestCurrentUser = createAction();
export const requestCurrentUserSuccess = createAction<IUser>();
export const requestCurrentUserFailed = createAction();

export const updateUser = createAction<IUser>();
export const updateUserSuccess = createAction();
export const updateUserFailed = createAction();
